import { FC } from 'react';

import { TranslatableText, useTranslate } from '@dreryk/react-common';

import { StyledMedicalLeaveFormSection } from './StyledMedicalLeaveFormSection';
import { StyledMedicalLeaveFormSectionHeader } from './StyledMedicalleaveFormSectionHeader';

type MedicalLeaveFormSectionProps = {
   readonly title: TranslatableText;
   readonly withRequiredMark?: boolean;
};

const MedicalLeaveFormSection: FC<MedicalLeaveFormSectionProps> = (props) => {
   const translate = useTranslate();
   return (
      <StyledMedicalLeaveFormSection>
         <StyledMedicalLeaveFormSectionHeader withRequiredMark={props.withRequiredMark}>
            {translate(props.title)}
         </StyledMedicalLeaveFormSectionHeader>
         {props.children}
      </StyledMedicalLeaveFormSection>
   );
};

export { MedicalLeaveFormSection };
